import { render, staticRenderFns } from "./ExportAppointmentData.vue?vue&type=template&id=83058b46&scoped=true&"
import script from "./ExportAppointmentData.vue?vue&type=script&lang=js&"
export * from "./ExportAppointmentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83058b46",
  null
  
)

export default component.exports